import {useIntl} from 'react-intl';


/**
 * Returns a percentage formatted number
 *
 * @param taxRate {number} Number to format to percentage. Can take 0-100 or 0-1 ranges
 */
function usePercentage(taxRate) {

    const {formatNumber} = useIntl();
    const percentageRang = taxRate > 1
        ? taxRate / 100
        : taxRate;

    return formatNumber(percentageRang, {
        maximumFractionDigits: 2,
        style: 'percent'
    });
}


export default usePercentage;
